import { type AlertProps } from "@mantine/core";

import { type PatternsTextingNotice } from "~/types";

export interface PatternsTextingNoticeAlertProps extends AlertProps {
  notice: PatternsTextingNotice;
}

const PatternsTextingNoticeAlert: FC<PatternsTextingNoticeAlertProps> = ({
  notice,
  ...otherProps
}) => {
  return (
    <Alert
      variant="default"
      title={notice.message}
      my={12}
      mb={22}
      mx="auto"
      maw={440}
      py="xs"
      lh="xs"
      styles={{ body: { gap: 8 } }}
      {...otherProps}
    >
      {notice.subtext}
    </Alert>
  );
};

export default PatternsTextingNoticeAlert;
